<template>
  <div>
    <transition name="fade">
      <a href="#" v-scroll-to="'#top'" class="btn btn-info rounded-circle btn-smooth" v-show="isShow">
        <i-button type="primary" shape="circle" icon="ios-arrow-up"></i-button>
      </a>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue'
// @docs https://vue-scrollto.netlify.app/
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
})

import { Button } from 'view-design'
export default {
  components: {
    'i-button': Button,
  },
  data() {
    return {
      scrollY: 0,
    }
  },
  computed: {
    // スクロールトップボタンの 表示/非表示切り替え
    isShow() {
      // スクロールが200px以上で表示
      return this.scrollY > 200 ? true : false
    },
  },
  mounted() {
    // スクロールを取得
    window.addEventListener('scroll', this.onScroll)
    window.addEventListener('load', () => {
      this.onScroll()
    })
  },
  methods: {
    // スクロール値の取得
    onScroll() {
      this.scrollY = window.pageYOffset
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-smooth {
  position: fixed;
  bottom: 32px;
  right: 16px;
  z-index: 99;
  &__ico {
    font-weight: bold;
    font-size: 20px;
  }
}
</style>
